import { getItemWithExpiry } from "./localStorageUtils";

const AUTH_KEY = "user-info";

/**
 * Check if user is authenticated
 * @returns {boolean} true if user has valid auth data
 */
export const isAuthenticated = () => {
  const authData = getItemWithExpiry(AUTH_KEY);
  return !!authData && !!authData.token;
};

/**
 * Get current authentication token
 * @returns {string|null} token or null if not authenticated
 */
export const getAuthToken = () => {
  const authData = getItemWithExpiry(AUTH_KEY);
  return authData?.token || null;
};

/**
 * Get current user data
 * @returns {Object|null} user data or null if not authenticated
 */
export const getCurrentUser = () => {
  return getItemWithExpiry(AUTH_KEY);
};

/**
 * Force logout user - clear auth data and redirect to login
 */
export const forceLogout = () => {
  localStorage.removeItem(AUTH_KEY);
  // Force page reload to clear any remaining state
  window.location.href = "/login";
};

/**
 * Validate token and auto-logout if invalid
 * @returns {boolean} true if token is valid
 */
export const validateToken = () => {
  const authData = getItemWithExpiry(AUTH_KEY);

  if (!authData || !authData.token) {
    forceLogout();
    return false;
  }

  return true;
};

/**
 * Check if token is about to expire (within 5 minutes)
 * @returns {boolean} true if token will expire soon
 */
export const isTokenExpiringSoon = () => {
  const itemStr = localStorage.getItem(AUTH_KEY);
  if (!itemStr) return true;

  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds

    // Return true if token will expire within 5 minutes
    return (item.expiry - now.getTime()) < fiveMinutes;
  } catch {
    return true;
  }
};